import {
    SET_EDITOR_UTILITIES
} from 'redux/actions/types/formBuilder';

const INITIAL_STATE = {
    utilities: null
};

const formBuilderReducer = (state = INITIAL_STATE, action) => {
    const { type, utilities } = action;

    switch (type) {
        case SET_EDITOR_UTILITIES:
            return { 
                ...state, 
                utilities,
            }

        default:
            return state
    }
};

export default formBuilderReducer;
